import Link from 'next/link';
import { FaLinkedinIn, FaTelegramPlane } from 'react-icons/fa';
import { IoLogoInstagram } from 'react-icons/io';

import Container from '@/components/@base/container';

import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';
import { socialLinks } from '@/constant/social-links';

import Bale from '~/images/icons/bale';

export default function Icons() {
  return (
    <Container className='flex gap-3'>
      <Link
        href={socialLinks.bale}
        passHref={true}
        target='_blank'
        aria-label='telegram'
        className='flex h-10 w-10 items-center justify-center rounded-md bg-[#F9FAFC] text-[#C1C3C8]! hover:text-[#FF9606]!'
      >
        <Bale />
      </Link>
      <Link
        href={socialLinks.instagram}
        passHref={true}
        target='_blank'
        aria-label='instagram'
        className='group/item flex h-10 w-10 items-center justify-center rounded-md bg-[#F9FAFC]'
      >
        <IoLogoInstagram
          color={ICON_COLOR.smoke}
          size={27}
          className='group-hover/item:text-[#FF9606]!'
        />
      </Link>
      <Link
        href={socialLinks.linkedin}
        passHref={true}
        target='_blank'
        aria-label='linkdin'
        className='group/item flex h-10 w-10 items-center justify-center rounded-md bg-[#F9FAFC]'
      >
        <FaLinkedinIn
          color={ICON_COLOR.smoke}
          size={21}
          className='group-hover/item:text-[#FF9606]!'
        />
      </Link>
      <Link
        href={socialLinks.telegram}
        passHref={true}
        target='_blank'
        aria-label='telegram'
        className='group/item flex h-10 w-10 items-center justify-center rounded-md bg-[#F9FAFC]'
      >
        <FaTelegramPlane
          color={ICON_COLOR.smoke}
          size={ICON_SIZE.md}
          className='group-hover/item:text-[#FF9606]!'
        />
      </Link>
    </Container>
  );
}
